export const PALLYCON_LA_URL = 'https://license.pallycon.com/ri/licenseManager.do';
export const PALLYCON_CUSTOM_HEADER = 'pallycon-customdata-v2';
